// Display helpers for the server's water balance (GET /api/irrigation/balance).

const fmtTime = (iso, lang) => new Date(iso).toLocaleString(lang === 'en' ? 'en-GB' : 'tr-TR',
    { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

// ET0 row of the field panel: rolling 24 h daily FAO-56 (what irrigation uses) + hourly indicator.
export function et0Display(balance, lang) {
    const e = balance?.et0;
    if (!e) return { value: null, perHour: null, stale: false, title: undefined };
    const en = lang === 'en';
    const title = `SWAMED FAO-56 · ${en ? 'last 24 h to' : 'son 24 saat, bitiş'} ${fmtTime(e.windowEnd, lang)}`
        + (e.fresh ? '' : (en ? ' · STALE — not used for irrigation' : ' · ESKİ — sulamada kullanılmıyor'));
    return { value: e.rolling24hMm, perHour: e.mmPerHour, stale: !e.fresh, title };
}

// Water balance box text.
export function recommendationText(balance, lang) {
    const en = lang === 'en';
    if (balance.mode === 'OFF') return en ? 'Control plot — not irrigated' : 'Kontrol parseli — sulanmıyor';
    const r = balance.recommendation;
    if (!r?.needed) {
        const t = balance.settings?.triggerDeficitMm;
        return en ? `No irrigation needed (trigger ${t} mm)` : `Sulama gerekmiyor (eşik ${t} mm)`;
    }
    if (r.minutes == null) {
        return en ? `Irrigate ${r.mm} mm (set the application rate to get a duration)`
                  : `Sulama gerekli: ${r.mm} mm (süre için sulama hızını girin)`;
    }
    const cap = r.capped ? (en ? ' (max run)' : ' (en uzun süre)') : '';
    return en ? `Irrigate ${r.mm} mm ≈ ${r.minutes} min${cap}` : `Sulama gerekli: ${r.mm} mm ≈ ${r.minutes} dk${cap}`;
}

const COVERAGE_WARN = 0.9;

export function statusNotes(balance, lang) {
    const en = lang === 'en';
    const notes = [];
    if (balance.kcMissing) notes.push(en ? 'Kc not set — using 1.0' : 'Kc girilmedi — 1,0 kullanılıyor');
    const c = balance.coverage;
    if (c && c.hours > 0 && c.withData / c.hours < COVERAGE_WARN) {
        const gap = c.hours - c.withData;
        notes.push(en ? `Weather data missing for ${gap} h` : `${gap} saat hava verisi eksik`);
    }
    return notes;
}

// Drip system: emitter flow (L/h) × emitters over the field area (m²) → mm/h (1 L/m² = 1 mm).
export function emitterRateMmH({ litresPerHour, emitters, areaM2 }) {
    const v = (Number(litresPerHour) * Number(emitters)) / Number(areaM2);
    return Number.isFinite(v) && v > 0 ? Math.round(v * 100) / 100 : null;
}
